import { Theme } from '@mui/system';

import { theme } from '@vp/theme/theme';

export const useSystemTheme = (): Theme => theme;
